import React from "react";
import NewFeedView from "../views/NewFeedView";

const NewFeed: React.FC = () => {
    return <div><NewFeedView /></div>;
};

export default NewFeed;